import React from 'react';
import PropTypes from 'prop-types';
import FullLogo from '../../assets/img/redesign/fullLogo.png';
import Typography from '../../components/Typography';
import Button from '../../components/Button';
import { useBreakpoint } from '../../hooks/useBreakpoint';

const LoggedOutHeader = ({ showSignUp }) => {
  const breakpoint = useBreakpoint();
  return (
    <>
      <div className="left">
        <a href="https://www.medsender.com/">
          <img src={FullLogo} width="185px" alt="fullLogo.png" />
        </a>
      </div>
      {
          showSignUp && breakpoint !== 'xsmall'
          && (
            <div className="right">
              <Typography variant="text" size="medium" bold>
                Want to demo Medsender?
              </Typography>
              <Button label="Sign up" href="https://www.medsender.com/sign-up?ref=loginpage" size="medium" />
            </div>
          )
        }
    </>
  );
};

LoggedOutHeader.propTypes = {
  showSignUp: PropTypes.bool,
};

LoggedOutHeader.defaultProps = {
  showSignUp: true,
};

export default LoggedOutHeader;
